var map = {
	"./aio700.png": 8832,
	"./cloud_meeting.png": 4571,
	"./default-product.svg": 5247,
	"./lx680.jpg": 5828,
	"./lxxxx450.jpg": 3375,
	"./mbs_studio.jpg": 9677,
	"./server.svg": 631
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4634;